import { useEffect, useState, useRef } from 'react';
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
// import InputAdornment from '@mui/material/InputAdornment';
import { useTheme } from '@mui/material/styles';
import {
  CardContent,
  Grid,
  Button,
  TextField,
  Typography,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  // Tooltip,
  InputLabel,
  MenuItem,
  Select,
  Box,
  Checkbox,
  Stack,
  Alert,
} from '@mui/material';
import { getreferenceLabel } from './ascertain.util';
import styles from './styles';

const EirKeepLandlineCollapseContent = ({
  radioValue,
  handleRadioChange,
  showContent,
  setCheckMark,
  setFixedLineCheckMark,
  areacodes,
  setPSTNLandline,
  bbQAResult,
  bbAccountFound,
  getQAForFixedline,
  errorUANModal,
  setfixedlineUan,
  setLandlineno,
  setKeepNumberStateInError,
  uanDetails,
}) => {
  const theme = useTheme();
  // const isShiftTab = useRef(false);
  const firstRadioRef = useRef(null);
  const [prefix, setPrefix] = useState();
  const [checked, setChecked] = useState(false);
  const [enableCta, setEnableCTA] = useState(false);
  const [disableEditing, setdisableEditing] = useState(false);
  const [referenceNumberError, setReferenceNumberError] = useState(false);
  const [landlineNumberError, setLandlineNumberError] = useState(false);
  const [referenceNumber, setReferenceNumber] = useState();
  const [landlineNumber, setLandlineNumber] = useState();
  const [refrenceData, setrefrenceData] = useState({
    referenceNumberLabel: '',
    referenceNumberAlertDescription: '',
    checkProvider: false,
  });
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      },
    },
  };
  const handleSubmit = async () => {
    if (bbQAResult) {
      setPSTNLandline(true);
      setLandlineno(bbQAResult.phoneNumber);
      setCheckMark(true);
      setFixedLineCheckMark(true);
      return;
    }
    let landline = '';
    if (prefix) {
      landline = `${prefix}-${landlineNumber}`;
    } else {
      landline = landlineNumber;
    }
    if (!referenceNumberError && !landlineNumberError && checked) {
      const { result, errors } = await getQAForFixedline(referenceNumber, landline);
      if (result?.getQAForFixedline?.serviceDetails?.activeServices) {
        if (
          (result?.getQAForFixedline?.serviceDetails?.activeServices.filter(
            service => service === 'VOBB'
          ).length &&
            !bbAccountFound) ||
          (result?.getQAForFixedline?.serviceDetails?.activeServices.filter(
            service => service === 'PSTN'
          ).length &&
            bbAccountFound)
        ) {
          errorUANModal.enable();
        }
        // if (
        //   (result?.getQAForFixedline?.serviceDetails?.activeServices[0] === 'VOBB' &&
        //     !bbAccountFound) ||
        //   (result?.getQAForFixedline?.serviceDetails?.activeServices[0] === 'PSTN' &&
        //     bbAccountFound)
        // ) {
        //   errorUANModal.enable();
        // }
      } else if (errors === 'Query Account not found') {
        setCheckMark(true);
        setFixedLineCheckMark(true);
        setLandlineno(landline);
        setfixedlineUan(referenceNumber);
        setKeepNumberStateInError(true);
      } else {
        // code for general error modal
        errorUANModal.enable();
      }
    }
  };

  useEffect(() => {
    const prefixValue = Boolean(prefix) || disableEditing;
    if (
      Boolean(referenceNumber) &&
      Boolean(landlineNumber) &&
      checked &&
      prefixValue &&
      !landlineNumberError &&
      !referenceNumberError
    ) {
      setEnableCTA(true);
    } else {
      setEnableCTA(false);
    }
  }, [referenceNumber, landlineNumber, checked, prefix]);
  useEffect(() => {
    setPrefix(prefix);
    if (bbQAResult) {
      setdisableEditing(true);
      setReferenceNumber(bbQAResult?.accountNumber);
      setLandlineNumber(bbQAResult?.phoneNumber);
      setEnableCTA(true);
    }
  }, [bbQAResult]);

  useEffect(() => {
    if (uanDetails.provider === 'VIRGIN MEDIA') setReferenceNumber(uanDetails.number);
    const result = getreferenceLabel(uanDetails);
    setrefrenceData({
      ...refrenceData,
      referenceNumberLabel: result?.labelName,
      referenceNumberAlertDescription: result?.labelDescription,
      checkProvider: uanDetails.provider === 'VIRGIN MEDIA',
    });
  }, [showContent]);
  const handleUANChange = event => {
    if (event.target.id === 'referenceno') {
      const referenceNumberValue = event.target.value.replace(/[^A-Za-z0-9]/g, '');
      if (uanDetails.provider === 'SKY') {
        if (event.target.value.match(/^(PO|SV)?[A-Za-z0-9]{10,12}$/)) {
          setReferenceNumberError(false);
        } else {
          setReferenceNumberError(true);
        }
      } else if (event.target.value.match(/^[A-Za-z]\d{10}$|^\d{10}$/)) {
        setReferenceNumberError(false);
      } else {
        setReferenceNumberError(true);
      }
      setReferenceNumber(referenceNumberValue);
    } else if (event.target.id === 'landlineno') {
      if (event.target.value.match(/^[0-9]{5,7}$/)) {
        setLandlineNumberError(false);
      } else {
        setLandlineNumberError(true);
      }
      setLandlineNumber(event.target.value);
    }
  };
  const handleChange = event => {
    // checkEnablecta();
    setChecked(event.target.checked);
  };

  return (
    <CardContent sx={styles(theme).collapseContainer}>
      <Grid container>
        <Grid item xs={12}>
          <FormControl>
            <RadioGroup
              row
              name='yes-no'
              value={radioValue}
              onChange={handleRadioChange}
              tabIndex={0}
              onFocus={e => {
                if (e.relatedTarget && e.currentTarget.contains(e.relatedTarget)) return;

                if (
                  e.relatedTarget &&
                  // eslint-disable-next-line no-bitwise
                  e.relatedTarget.compareDocumentPosition(e.currentTarget) & 2
                ) {
                  return;
                }

                firstRadioRef.current?.focus();
              }}
              onKeyDown={event => {
                // isShiftTab.current = event.shiftKey && event.key === 'Tab';
                // if (isShiftTab.current) return;
                const radios = Array.from(
                  event.currentTarget.querySelectorAll('input[type="radio"]')
                );
                const active = document.activeElement;
                const index = radios.indexOf(active);

                // Arrow keys → move focus only
                if (['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].includes(event.key)) {
                  event.preventDefault();

                  let next = index;
                  if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
                    next = (index + 1) % radios.length;
                  } else {
                    next = (index - 1 + radios.length) % radios.length;
                  }

                  radios[next]?.focus();
                  return;
                }

                // Enter → trigger selection (with visible dot)
                if (event.key === 'Enter') {
                  event.preventDefault();
                  active?.click(); // triggers MUI selection & your onChange
                }
              }}
              sx={{
                ...styles(theme).radioButton,

                '&.Mui-focusVisible': {
                  outline: 'none',
                },
                '&:focus-visible': {
                  outline: 'none',
                },
                outline: 'none',

                '&[tabindex="0"]': {
                  outline: 'none',
                },
              }}
            >
              <FormControlLabel
                value='yes'
                control={<Radio inputRef={firstRadioRef} />}
                label='Yes'
              />
              <FormControlLabel value='no' control={<Radio />} label='No' />
            </RadioGroup>
          </FormControl>
        </Grid>
        {showContent && (
          <>
            <Grid container item xs={12} sm={5}>
              <Grid item xs={12} sm={10}>
                <TextField
                  fullWidth
                  label={refrenceData.referenceNumberLabel || 'Your reference number'}
                  id='referenceno'
                  disabled={disableEditing || refrenceData.checkProvider}
                  onChange={handleUANChange}
                  value={referenceNumber}
                  required
                  sx={styles(theme).inputTextbox}
                  {...(referenceNumber ? { defaultValue: referenceNumber } : {})}
                  inputProps={{
                    style: { color: theme.palette.primary.textColor3 },
                    maxLength: uanDetails.provider === 'SKY' ? 12 : 10,
                    // endAdornment: (
                    //   <InputAdornment position='end'>
                    //     {' '}
                    //     <Tooltip
                    //       title='Reference number must contain only numbers'
                    //       enterDelay={200}
                    //       leaveDelay={800}
                    //       enterTouchDelay={0}
                    //     >
                    //       <InfoOutlinedIcon sx={{ color: 'rgba(50, 52, 53, 0.54)' }} />
                    //     </Tooltip>
                    //   </InputAdornment>
                    // ),
                  }}
                />

                {referenceNumberError && (
                  <Typography variant='body2' sx={styles(theme).errorMessage}>
                    {uanDetails.provider === 'SKY'
                      ? 'Reference number can contain letters, numbers and will be 10 to 12 digits long'
                      : 'Reference number must be 10 digits long and can contain only numbers'}
                  </Typography>
                )}
              </Grid>
            </Grid>
            <Grid container item xs={12} sm={4} sx={styles(theme).landlineprefix}>
              {disableEditing && (
                <Grid xs={12} sm={12}>
                  <TextField
                    fullWidth
                    label='Landline number'
                    id='landlineno'
                    disabled={disableEditing}
                    onChange={handleUANChange}
                    required
                    sx={styles(theme).inputTextbox}
                    {...(landlineNumber ? { defaultValue: landlineNumber } : {})}
                    InputProps={{
                      style: { color: theme.palette.primary.textColor3 },
                    }}
                  />
                  {landlineNumberError && (
                    <Typography variant='body2' sx={styles(theme).errorMessage}>
                      Phone number must be between 9 and 13 digits
                    </Typography>
                  )}
                </Grid>
              )}

              {!disableEditing && (
                <>
                  <Grid xs={3} sm={3.6} sx={{ marginRight: '6px' }}>
                    <FormControl required fullWidth sx={styles(theme).inputTextbox}>
                      <InputLabel
                        id='prefix-label'
                        sx={{ color: theme.palette.primary.buttonColor }}
                      >
                        Prefix
                      </InputLabel>
                      <Select
                        labelId='Prefix'
                        id='Prefix'
                        value={prefix}
                        label='Prefix'
                        MenuProps={MenuProps}
                        sx={{
                          '& .MuiSvgIcon-root': { color: theme.palette.primary.buttonColor },
                        }}
                        onChange={e => setPrefix(e.target.value)}
                      >
                        {areacodes?.map(areacode => (
                          <MenuItem
                            value={areacode.AREA_CODE}
                            onChange={e => setPrefix(e.target.value)}
                            sx={{
                              '& .MuiSvgIcon-root': { color: theme.palette.primary.buttonColor },
                              color: theme.palette.primary.textColor3,
                            }}
                          >
                            {areacode.AREA_CODE}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid xs={8.6} sm={8.1}>
                    <TextField
                      fullWidth
                      label='Landline number'
                      id='landlineno'
                      disabled={disableEditing}
                      onChange={handleUANChange}
                      required
                      sx={styles(theme).inputTextbox}
                      {...(landlineNumber ? { defaultValue: landlineNumber } : {})}
                      inputProps={{
                        maxLength: 7,
                        style: { color: theme.palette.primary.textColor3 },
                      }}
                    />
                    {landlineNumberError && (
                      <Typography variant='body2' sx={styles(theme).errorMessage}>
                        Phone number must be between 5 and 7 digits
                      </Typography>
                    )}
                  </Grid>
                </>
              )}
            </Grid>
            {!!refrenceData.referenceNumberAlertDescription && !disableEditing && (
              <Alert
                severity='info'
                sx={{
                  '& .MuiSvgIcon-root': { color: theme.palette.secondary.OfferSelected },
                  mt: '24px',
                }}
              >
                <span style={{ color: theme.palette.secondary.OfferSelected }}>
                  {refrenceData.referenceNumberAlertDescription}
                </span>
              </Alert>
            )}
            <Grid container item xs={12}>
              <Box sx={{ marginTop: 2 }}>
                <Stack
                  direction='row'
                  justifyContent='flex-start'
                  alignItems='flex-start'
                  spacing={0}
                >
                  <Typography
                    variant='body1'
                    sx={{
                      color: theme.palette.primary.textColor3,
                      pl: 0,
                      pr: 1,
                      pt: 1,
                      pb: 1,
                    }}
                  >
                    Our home phone service works through your broadband modem, not via a separate
                    landline. This means it requires a power supply. If you have a monitored alarm
                    or panic alarm that requires a connection to a landline, this will not work with
                    this phone service.
                  </Typography>
                </Stack>
              </Box>
            </Grid>
            <Grid container item xs={12}>
              <Checkbox
                name='termsAndCondition'
                id='termsAndCondition'
                sx={{
                  color: theme.palette.primary.textColor3,
                  '&.Mui-checked': {
                    color: theme.palette.primary.textColor3,
                  },
                  // pt: 0,
                  // pl: 0,
                }}
                checked={checked}
                onClick={handleChange}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    e.target.click();
                  }
                }}
              />
              <span style={{ color: theme.palette.primary.textColor3, marginTop: '9px' }}>
                I accept the above
              </span>
            </Grid>
            <Grid container direction='row' justifyContent='center'>
              <Button
                variant='buttonMedium'
                onClick={handleSubmit}
                sx={enableCta ? styles(theme).enableSubmitCTA : styles(theme).disableSubmitCTA}
                aria-label='Submit landline information'
              >
                Submit
              </Button>
            </Grid>
          </>
        )}
      </Grid>
    </CardContent>
  );
};

export default EirKeepLandlineCollapseContent;
